import { useTheme } from '@mui/material'

import { FONTS } from 'src/constants'

export const RenderActiveDot = (props: any) => {
  const theme = useTheme()
  const { cx, cy, value } = props

  return (
    <svg x={cx - 27} y={cy - 55} width="54" height="68" viewBox="0 0 54 68">
      <text
        textAnchor="middle"
        dy={40}
        dx={27}
        fontSize={FONTS.SIZES.xl}
        fontWeight={FONTS.WEIGHTS.bold}
        fill={theme.palette.custom.primary}
      >
        {value}
      </text>
      <rect
        x="19.9297"
        y="47"
        width="14"
        height="14"
        rx="7"
        fill={theme.palette.custom.primary}
        stroke="white"
        strokeWidth="3"
      />
    </svg>
  )
}
